import type { FC, ReactNode } from 'react'

import { Phone } from 'lucide-react'
import { WhatsAppIcon } from '@/components/generals/icons'
import { contactInfo, whatsappLink } from '@/constants/site'

export const FloatingActions: FC = (): ReactNode => {
    return (
        <div className='fixed right-4 bottom-4 z-40 flex flex-col items-end gap-3 sm:right-6 sm:bottom-6'>
            <a
                href={contactInfo.phoneHref}
                aria-label={`Call Guju Events on ${contactInfo.phoneDisplay}`}
                className='focus-ring group inline-flex size-13 items-center justify-center rounded-full bg-crimson text-white shadow-[0_14px_30px_-10px_rgba(212,31,58,0.9)] transition-transform hover:-translate-y-0.5'
            >
                <Phone className='size-5' aria-hidden='true' />
            </a>

            <a
                href={whatsappLink('Hi Guju Events, I would like to plan an event.')}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Chat with Guju Events on WhatsApp'
                className='focus-ring relative inline-flex size-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-[0_14px_30px_-10px_rgba(31,168,85,0.9)] transition-transform hover:-translate-y-0.5'
            >
                <span aria-hidden='true' className='absolute inset-0 rounded-full bg-whatsapp/60 motion-safe:animate-ping [animation-duration:2.4s]' />
                <WhatsAppIcon className='relative size-7' />
            </a>
        </div>
    )
}
